import o from"react";var t={color:void 0,size:void 0,className:void 0,style:void 0,attr:void 0},e=o.createContext&&o.createContext(t);export{t as DefaultContext,e as IconContext};
//# sourceMappingURL=iconContext.js.map
